module.exports = __webpack_public_path__ + "static/media/glide.0d2534eb.svg";